/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgResourceFacingService = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2v16h9v2H7v2h5.255A6.968 6.968 0 0 1 11 18c0-.695.101-1.366.29-2H9.074c.104-.622.311-1.033.574-1.306.378-.391 1.06-.694 2.352-.694.087 0 .17.001.252.004a7.039 7.039 0 0 1 1.747-1.749C13.396 12.078 12.724 12 12 12c-1.564 0-2.883.364-3.791 1.306-.689.714-1.03 1.647-1.154 2.694H4V4h16v7.29a6.972 6.972 0 0 1 2 .965V2z" />
        <path d="M12 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm12 11v-2h-1.141a3.956 3.956 0 0 0-.425-1.02l.808-.808-1.414-1.415-.808.809a3.956 3.956 0 0 0-1.02-.425V13h-2v1.141a3.956 3.956 0 0 0-1.02.425l-.808-.809-1.415 1.415.809.808c-.186.316-.33.656-.425 1.02H13v2h1.141c.095.364.239.704.425 1.02l-.809.808 1.414 1.414.809-.808c.316.186.656.33 1.02.425V23h2v-1.141a3.991 3.991 0 0 0 1.02-.425l.808.808 1.414-1.414-.808-.808c.187-.316.33-.656.425-1.02zm-5 1a2 2 0 1 1 .001-4.001A2 2 0 0 1 18 20z" />
      </g>
    </g>
  </Icon>
);
export { SvgResourceFacingService as ResourceFacingService };
